export class ReporteRefacturacionDTO {
  tipoComprobante: string;
  prefijoComprobante: string;
  numeroComprobante: string;
  comprobanteId: string;
  fechaHoraComprobante: string;
  producto: string;
  cliente: string;
  litrosDisponibles: number;
  litrosUtilizados: number;
  fechaVigenciaHasta: string;
}